/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApplicationConfiguration } from '../models/application-configuration';
import { applicationConfigurationsControllerGetConfiguration } from '../fn/application-configurations-controller/application-configurations-controller-get-configuration';
import { ApplicationConfigurationsControllerGetConfiguration$Params } from '../fn/application-configurations-controller/application-configurations-controller-get-configuration';


/**
 * Represents API endpoints for application configurations.
 */
@Injectable({ providedIn: 'root' })
export class ApplicationConfigurationsControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `applicationConfigurationsControllerGetConfiguration()` */
  static readonly ApplicationConfigurationsControllerGetConfigurationPath = '/planning-projects/v1/application-configurations';

  /**
   * Returns an configuration for the current application instance.
   *         If no <code>fields</code> query parameter is provided, full configuration is returned.
   *         If one or more <code>fields</code> query params are provided (e.g. fields=flows&fields=features),
   *         only selected fields are returned together with always-present meta fields: level, applicationId, instance.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `applicationConfigurationsControllerGetConfiguration()` instead.
   *
   * This method doesn't expect any request body.
   */
  applicationConfigurationsControllerGetConfiguration$Response(params?: ApplicationConfigurationsControllerGetConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<ApplicationConfiguration>> {
    return applicationConfigurationsControllerGetConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns an configuration for the current application instance.
   *         If no <code>fields</code> query parameter is provided, full configuration is returned.
   *         If one or more <code>fields</code> query params are provided (e.g. fields=flows&fields=features),
   *         only selected fields are returned together with always-present meta fields: level, applicationId, instance.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `applicationConfigurationsControllerGetConfiguration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  applicationConfigurationsControllerGetConfiguration(params?: ApplicationConfigurationsControllerGetConfiguration$Params, context?: HttpContext): Observable<ApplicationConfiguration> {
    return this.applicationConfigurationsControllerGetConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApplicationConfiguration>): ApplicationConfiguration => r.body)
    );
  }

}
